import React from 'react'

import { AuthApolloProvider } from './apollo/AuthApolloProvider'
import { MainLayout } from 'modulesCommon/MainLayout/containers'
import { AuthenticationProvider } from 'providers/AuthenticationProvider'
import { AuthorizationProvider } from 'providers/AuthorizationProvider'

const App = () => {
  // The order of the providers is important:
  // 1. AuthenticationProvider
  // 2. AuthApolloProvider
  // 3. AbilityProvider
  return (
    <AuthenticationProvider>
      <AuthApolloProvider>
        <AuthorizationProvider>
          <MainLayout />
        </AuthorizationProvider>
      </AuthApolloProvider>
    </AuthenticationProvider>
  )
}

export default App
